const mergeTimeSheetEntries = (data, localData) => {
  let newData = [...data];
  for (let i = 0; i < localData.length; i++) {
    const log = localData[i];
    const logDateAsDay = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'][
      new Date(log.date).getDay()
    ];
    const indexOfStageToUpdate = newData.findIndex(
      (x) => x.stageId === log.stageId && x.area === log.area
    );
    newData[indexOfStageToUpdate][logDateAsDay] = log;
  }
  return newData;
};

export default mergeTimeSheetEntries;
